export default {
  'pages.todo.adminTitle': '待办管理',
  'pages.todo.consoleTitle': '我的待办',
  'pages.todo.adminDesc': '查看与管理全部用户的待办事项，支持按用户 / 关键词 / 状态过滤。',
  'pages.todo.consoleDesc': '管理归属当前账号的待办事项。',
  'pages.todo.new': '新建待办',
  'pages.todo.colTitle': '标题',
  'pages.todo.colContent': '内容',
  'pages.todo.colPriority': '优先级',
  'pages.todo.colRemindAt': '提醒时间',
  'pages.todo.colRepeatRule': '重复',
  'pages.todo.colStatus': '状态',
  'pages.todo.colSource': '来源',
  'pages.todo.colUser': '归属用户',
  'pages.todo.colUserIdFilter': '用户ID',
  'pages.todo.colUsernameFilter': '用户名',
  'pages.todo.colDeviceFilter': '设备MAC',
  'pages.todo.colDevice': '设备',
  'pages.todo.colKeyword': '关键词',
  'pages.todo.keywordPlaceholder': '标题或内容关键词',
  'pages.todo.deviceTip': '选择关联的设备，可留空',
  'pages.todo.deviceSelectPlaceholder': '选择设备（名称 / MAC）',
  'pages.todo.noDevice': '未找到设备',
  'pages.todo.colCreatedAt': '创建时间',
  'pages.todo.colActions': '操作',
  'pages.todo.complete': '完成',
  'pages.todo.edit': '编辑',
  'pages.todo.delete': '删除',
  'pages.todo.batchDelete': '批量删除',
  'pages.todo.confirmDelete': '确定删除该待办？',
  'pages.todo.confirmBatchDelete': '确定删除选中的待办？删除后不可恢复。',
  'pages.todo.selectedCount': '已选 {count} 项',
  'pages.todo.batchDeleted': '已删除 {count} 条',
  'pages.todo.batchDeletePartial': '有 {fail} 条删除失败',
  'pages.todo.confirm': '确定',
  'pages.todo.cancel': '取消',
  'pages.todo.created': '创建成功',
  'pages.todo.updated': '更新成功',
  'pages.todo.completed': '已完成',
  'pages.todo.completedRepeat': '已完成本次，下次提醒已顺延',
  'pages.todo.deleted': '已删除',
  'pages.todo.opFail': '操作失败',
  'pages.todo.titleRequired': '请输入标题',
  'pages.todo.remindAtPlaceholder': '选择提醒时间（本地时区）',
  'pages.todo.targetUser': '归属用户',
  'pages.todo.targetUserTip': '留空则归属当前登录账号',
  'pages.todo.targetUserReadonlyTip': '编辑时不可变更归属用户',
  'pages.todo.userIdPlaceholder': '输入用户ID过滤',
  'pages.todo.usernamePlaceholder': '输入用户名过滤',
  'pages.todo.devicePlaceholder': '输入设备MAC过滤',
  'pages.todo.searchUserPlaceholder': '输入用户名搜索选择',
  'pages.todo.noUserFound': '未找到用户',

  // 优先级 / 来源 / 重复 / 状态标签
  'pages.todo.priority.normal': '普通',
  'pages.todo.priority.important': '重要',
  'pages.todo.priority.urgent': '紧急',
  'pages.todo.source.user': '用户',
  'pages.todo.source.admin': '管理端',
  'pages.todo.source.device': '设备',
  'pages.todo.repeat.none': '不重复',
  'pages.todo.repeat.daily': '每天',
  'pages.todo.repeat.weekly': '每周',
  'pages.todo.repeat.monthly': '每月',
  'pages.todo.status.todo': '待办',
  'pages.todo.status.done': '已完成',
};
